@if (categories.length > 0 && activeCategory) {
  <div class="select-categories">
    <div class="row">
      @for (category of categories; track category) {
        <div class="col-4 text-center">
          <div
            class="menu-item"
            [ngClass]="[activeCategory.id === category.id ? 'active' : '']"
            (click)="activeCategory = category; this.updateSelectedCounter()"
          >
            <div class="name-container">
              <span class="name">{{ category.name }}</span>
              <div class="badge-counter-container">
                <div class="badge-counter">
                  <span class="counter">
                    {{ getCategoryCounter(category) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
    <div class="categories-container">
      <ng-scrollbar track="vertical" appearance="compact" visibility="hover">
        <div class="row categories-info">
          <div class="col-6 selected-counter">
            {{ 'global.selected' | transloco }}:
            <span class="number">
              {{ selectedCounter }}
            </span>
          </div>
          <div class="col-6 text-right">
            @if (!unselectActive) {
              <button type="button" class="btn btn-select-all" (click)="selectAllCategories()">
                {{ 'global.select_all' | transloco }}
              </button>
            }
            @if (unselectActive) {
              <button type="button" class="btn btn-select-all" (click)="unselectAllCategories()">
                {{ 'global.unselect_all' | transloco }}
              </button>
            }
          </div>
        </div>
        @if (activeCategory) {
          <ul class="categories">
            @for (subCategory of activeCategory.subcategories; track subCategory) {
              <li [ngClass]="{ active: isCategorySelected(subCategory.id) }" (click)="toggleCategory(subCategory.id)">
                {{ subCategory.name }}
              </li>
            }
          </ul>
        }
      </ng-scrollbar>
    </div>
  </div>
}
